/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const EditIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path d="M21.268 2.732a2.5 2.5 0 0 0-3.535 0L16.63 3.834l3.535 3.535 1.102-1.102a2.5 2.5 0 0 0 0-3.535M19.155 8.38 15.62 4.844 4.05 16.416a5 5 0 0 0-1.257 2.108l-.762 2.558a.714.714 0 0 0 .888.888l2.557-.762a5 5 0 0 0 2.11-1.257z" /></svg>;
};
export default EditIcon;